<template>
  <RouterLink
    class="flex cursor-pointer items-center overflow-hidden rounded-lg p-1 pl-0 text-gray-400 hover:bg-white"
  >
    <BaseIcon name="arrow-left-s" class="mt-0.5 text-xl" />
    <span>
      <slot />
    </span>
  </RouterLink>
</template>

<script setup>
import { BaseIcon } from "@repowerednl/ui-component-library"
</script>
